import { Heading } from "@/components/Heading/Heading";
import { Scene } from "@/components/Scene/Scene";
import css from "./PageWithScene.module.scss";

type Props = {
  heading: string;
  scene: React.ComponentProps<typeof Scene>["scene"];
  children?: React.ReactNode;
};

export function PageWithScene({ heading, scene, children }: Props) {
  return (
    <div className={css.root}>
      <main className={css.main}>
        <Heading>{heading}</Heading>
        <Scene scene={scene} />

        {children}
      </main>
    </div>
  );
}
